import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import user_module from '@/modules/user';

import VueLodash from 'vue-lodash'
// @ts-ignore
import lodash from 'lodash'

import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primevue/resources/themes/saga-blue/theme.css'

import ToastService from 'primevue/toastservice';
import {axios, newAPIAxios} from "@/plagins";

Vue.config.productionTip = false

const fingerPrint = user_module.Fingerprint;
const token = user_module.Token;
const login = user_module.Login;

if (token){

  axios.defaults.headers.common['Token'] = token;

  newAPIAxios.defaults.headers.common['Token'] = token;

  if (fingerPrint){
    
    axios.defaults.headers.common['fingerprint'] = fingerPrint;
    newAPIAxios.defaults.headers.common['fingerprint'] = fingerPrint;

    //for Tech Market
    localStorage.setItem('fingerPrint', fingerPrint);

    localStorage.setItem('AppToken', token);

    if (login){
      
      localStorage.setItem('AppLogin', login);

    }

  }

}





Vue.use(ToastService)
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })
// @ts-ignore
window._ = require('lodash');
// Vue.use(pdfOjb)

export const eventBus = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

